import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../../utils/api/axiosInstance";

const normalizeFavoriteIds = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.favorites)) return data.favorites;
  return [];
};

/**
 * React Query hook for fetching user's favorites
 * @param {string} userId - User ID
 * @param {boolean} enabled - Whether the query should run
 */
export const useFavoritesQuery = (userId, enabled = true) => {
  return useQuery({
    queryKey: ["favorites", userId],
    queryFn: async () => {
      const res = await api.get("/users/me/favorites");
      return normalizeFavoriteIds(res.data);
    },
    enabled: enabled && !!userId,
  });
};

/**
 * Mutation hook for deleting favorites
 */
export const useDeleteFavoritesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (productIds) => {
      const res = await api.delete("/users/me/favorites", {
        data: { productIds },
      });
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["favorites"]);
    },
  });
};
